export default __webpack_public_path__ + "static/epilogue-3adf323c468d9c840cbcae23727f141c.svg";